var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.templateArgs.showShortDate)?_c('span',[_vm._v(_vm._s(_vm.shortDateFormat))]):(_vm.templateArgs.showHourFormat)?_c('span',[_vm._v(_vm._s(_vm.hourFormat))]):_c('span',[_vm._v(_vm._s(_vm.longDateFormat))])}
var staticRenderFns = []

export { render, staticRenderFns }